export default __webpack_public_path__ + "static/media/stopwatch-light.cf227cb9.svg";